module.exports = __webpack_public_path__ + "static/media/xiuguluanshan_web.92a54a60.png";